import styled from 'styled-components'

export const StyledItemContent = styled.div`
  .rank-list-item {
    cursor: pointer;
    display: flex;
    align-items: center;
    border-bottom: 1px solid ${props => props.theme.light1};
    padding: 32px 0;
    background: #fff;

    &:last-child {
      border: none;
      padding-bottom: 0;
    }
    .left {
      display: flex;
      align-items: center;
      .rank-icon {
        width: 48px;
        height: 48px;
      }
      .rank-sort {
        padding: 6px 8px;
        background: ${props => props.theme.light2};
        border-radius: 4px;
        font-size: 18px;
        line-height: 20px;
        font-weight: 600;
        color: ${props => props.theme.dark4};
      }
      .creator-union {
        position: absolute;
        bottom: -1px;
        right: 2px;
        font-size: 30px;
      }
      .main-img {
        width: 224px;
        height: 112px;
        border-radius: 8px;
        margin-left: 24px;
        transition: all ease-in-out 180ms;
        &:hover {
          img {
            transform: scale(1.1);
            transition: all ease-in-out 180ms;
          }
        }
      }
      .creator {
        &:hover {
          img {
            transform: scale(1.1);
            transition: all ease-in-out 180ms;
          }
        }
      }
      .main-img_collection {
        width: 224px;
        height: 112px;
      }
      .main-img_works {
        width: 125px;
        height: 148px;
      }
      .creator-vip {
        bottom: 0;
        right: 0;
      }
      .product-tag-item {
        font-size: 12px;
        line-height: 12px;
        padding: 7px 8px;
        border-radius: 4px;
        color: ${props => props.theme.light3};
        background: rgba(0, 0, 0, 0.56);
        margin-right: 8px;
        display: inline-flex;
        align-items: center;
        position: absolute;
        left: 30px;
        top: 6px;
      }
    }
    .middle {
      flex: 1;
      margin: 0 24px;
      overflow: hidden;
      .title {
        font-weight: 600;
        font-size: 20px;
        line-height: 28px;
        color: ${props => props.theme.dark2};
        margin-bottom: 20px;

        .text {
          max-width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          word-break: break-all;
          &:hover {
            color: ${props => props.theme.primaryColor};
          }
        }
        .line-one {
          -webkit-line-clamp: 1;
        }
      }
      .info {
        display: flex;
        align-items: center;
        font-size: 14px;
        .name {
          color: #333;
          display: flex;
          align-items: center;
          &:hover {
            color: ${props => props.theme.primaryColor};
          }
        }
        .works-num {
          margin-left: 16px;
          color: ${props => props.theme.dark4};
          background: ${props => props.theme.light2};
          border-radius: 64px;
          padding: 4px 12px;
        }
        .creators {
          color: ${props => props.theme.dark4};
          align-items: center;
          .icon {
            font-size: 14px;
          }
        }
      }
      .value {
        display: flex;
        margin-top: 20px;
      }
    }
    .right {
      display: flex;
      color: ${props => props.theme.dark4};
      font-size: 14px;
      .collect {
        margin-left: 17px;
      }
      .icon {
        font-size: 14px;
      }
      .price {
        color: ${props => props.theme.errorColor};
        font-size: 16px;
      }
    }
  }
`

/** 首页卡片样式 */
export const StyledRankContent = styled.div`
  width: 294px;
  /* padding: 24px 16px; */
  margin-right: 24px;
  position: relative;
  .ant-select-dropdown {
    width: 74px !important;
  }
  &:last-child {
    margin-right: 0;
  }
  .top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 16px;
    margin-bottom: 16px;
    background-color: ${props => props.theme.light2};
    border-radius: 8px;
    height: 44px;
    .title {
      font-weight: 600;
      font-size: 16px;
      line-height: 24px;
      color: #000000;
    }
  }
  .rank-list {
    .item {
      cursor: pointer;
      display: flex;
      align-items: center;
      margin-bottom: 24px;
      &:hover {
        .right {
          .works-info {
            opacity: 1;
            margin-top: 0;
          }
        }
      }
      &:last-child {
        margin-bottom: 0;
      }
      .left {
        display: flex;
        align-items: center;
        .avatar {
          width: 72px;
          height: 72px;
          border-radius: 8px;
          margin: 0 12px;
          transition: all ease-in-out 180ms;
          &:hover {
            img {
              transform: scale(1.1);
              transition: all ease-in-out 180ms;
            }
          }
        }
        .creator {
          &:hover {
            img {
              transform: scale(1.1);
              transition: all ease-in-out 180ms;
            }
          }
        }
        .creator-vip {
          bottom: 1px;
          right: -1px;
        }
        .user {
          border-radius: 50%;
        }
      }
      .right {
        flex: 1;
        overflow: hidden;

        .desc {
          display: flex;
          align-items: center;
          font-weight: 600;
          font-size: 16px;
          line-height: 24px;
          color: ${props => props.theme.dark2};

          .title {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            max-width: 100%;
            &:hover {
              color: ${props => props.theme.primaryColor};
            }
          }
        }
        .name {
          overflow: hidden;
          display: flex;
          align-items: center;
          font-size: 12px;
          line-height: 20px;
          color: ${props => props.theme.dark2};
          margin-top: 4px;
          &:hover {
            color: ${props => props.theme.primaryColor};
          }
        }
        .works-info {
          display: flex;
          align-items: center;
          font-size: 12px;
          line-height: 20px;
          color: ${props => props.theme.dark4};
          margin-top: 4px;
          opacity: 0;
          margin-top: -20px;
          transition: all 0.3s ease-in-out;
          .icon {
            font-size: 12px;
            margin-right: 5px;
          }
        }
      }
    }
  }
`
/** 排名变化样式 */
export const StyleRankChange = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 16px;
  height: 28px;
  font-size: 12px;
  font-weight: 400;
  color: ${props => props.theme.dark5};
  border-radius: 14px;
  background-color: rgba(177, 181, 195, 0.16);

  &.up {
    background-color: rgba(239, 70, 111, 0.16);
    color: ${props => props.theme.errorColor};
  }
  &.down {
    background-color: rgba(69, 178, 107, 0.16);
    color: ${props => props.theme.successColor};
  }
  .rank {
    display: flex;
    align-items: center;
    &-num {
      margin-left: 2px;
    }
  }
  .tip {
    margin-left: 8px;
  }
  .triangle {
    border-width: 6px 5px;
    border-style: solid;
    border-color: transparent;
    &-up {
      transform: translateY(-30%);
      border-bottom-color: ${props => props.theme.errorColor};
    }
    &-down {
      transform: translateY(30%);
      border-top-color: ${props => props.theme.successColor};
    }
  }
`
